import { ThemeOptions } from '@mui/material/styles/createTheme';

import { tokens } from '../../theme/generated/tokens';
import { cssVars } from '../../utils/cssVars';

const vars = cssVars(
  {
    background: tokens.theme.bg.structural.surfaceInverse,
    color: tokens.theme.fg.structural.primaryOnInverse,
  },
  'ds-tooltip'
);

export const tooltipTheme: ThemeOptions['components'] = {
  MuiTooltip: {
    styleOverrides: {
      popper: ({ theme }) => ({
        zIndex: theme.zIndex.drawer + 1,
      }),
      tooltip: ({ theme }) => ({
        padding: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        ...theme.typography.P12R,
        backgroundColor: vars.refs.background,
        color: vars.refs.color,
        borderRadius: tokens.theme.radius.sm,
        maxWidth: 384,
        // Legacy variants: not covered with semantic tokens intentionally
        '&.DS-Tooltip-color-': {
          '&secondary': vars.setValues({
            background: tokens.primitives.colors.grey[200],
            color: tokens.primitives.colors.grey[700],
          }),
          '&tertiary': vars.setValues({
            background: tokens.primitives.colors.indigo[700],
            color: tokens.primitives.colors.constants.white,
          }),
        },

        '&.DS-Tooltip-size-small': {
          maxWidth: 288,
        },
      }),
      arrow: {
        '&:before': { color: vars.refs.background },
      },
    },
  },
};
